import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import HasPermissions from '../components/HasPermissions';

const StaffAvailability = ({ isAvailable }) => (
  <HasPermissions config="enable_staff_availability">
    <span className={`staff-circle ${isAvailable ? 'available' : ''}`} />
  </HasPermissions>
);

StaffAvailability.propTypes = {
  isAvailable: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  const {
    session: {
      permissions: {
        user,
      },
    },
  } = state;

  return {
    isAvailable: _.get(user, 'attributes.is_available', false),
  };
};

export default connect(mapStateToProps)(StaffAvailability);




// WEBPACK FOOTER //
// ./src/containers/StaffAvailability.js